import React from 'react';
import Canvas from './Canvas';
import UIControls from './UIControls';
import { CanvasProvider } from '../context/CanvasContext';

const CanvasPage = () => {
  return (
    <CanvasProvider>
      <div className="App">
        <Canvas />
        <UIControls />
      </div>
    </CanvasProvider>
  );
};

export default CanvasPage;

